import { UI_STYLES } from "../../styles/uiStyles";
import { PrognosisDomain } from "../../types/Prognosis";
import { formatDate } from "../../utils/iso8601ToDate";
import { useRef, useEffect } from "react";

interface PrognoseTopBarProps {
  prognoses: PrognosisDomain[];
  selectedPrognose: PrognosisDomain | null;
  selectPrognosis: (prognose: PrognosisDomain) => void;
}

export const PrognoseTopBar = ({
  prognoses,
  selectedPrognose,
  selectPrognosis,
}: PrognoseTopBarProps) => {

  const scrollRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const onWheel = (e: WheelEvent) => {
      if (e.deltaY === 0) return;
      e.preventDefault();
      el.scrollLeft += e.deltaY;
    };

    el.addEventListener("wheel", onWheel, { passive: false });
    return () => {
      el.removeEventListener("wheel", onWheel);
    };
  }, []);

  return (
    <div ref={scrollRef} className="inline-flex flex-row items-end gap-2 overflow-x-auto justify-start w-full hide-scrollbar  ">
      {prognoses.length > 0 &&
        prognoses.map((tab, index) => (
          <div key={tab.objectId} className="flex flex-col items-center gap-2">
            {index === 0 && (
              <div className="px-2 font-ubuntu text-xs font-light text-white/60 mb-1">
                Текущий прогноз
              </div>
            )}
            <button
              className={`flex-shrink-0 px-4 py-1 rounded-full font-ubuntu font-medium text-sm transition whitespace-nowrap focus:outline-none ${
                selectedPrognose?.objectId === tab.objectId
                  ? `${UI_STYLES.bgDarkBlue4} text-white`
                  : `${UI_STYLES.bgDarkBlue4}/40 text-white/60 ${UI_STYLES.bgDarkBlueHover} hover:text-white`
              }`}
              onClick={() => selectPrognosis(tab)}
              aria-current={
                selectedPrognose?.objectId === tab.objectId ? "true" : undefined
              }
            >
              {formatDate(tab.startDate ?? "")} -{" "}
              {formatDate(tab.endDate ?? "")}
            </button>
          </div>
        ))}
    </div>
  );
};
